const countries = {
  slug: 'f/live-bytes',
  getLiveBytes: () => `${countries.slug}`
}

export default countries
